/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Button as MuiButton, ButtonProps, CircularProgress } from '@mui/material'
import { JSX } from 'react'

type Props = {
  loading?: boolean
  progressClasses?: any
} & ButtonProps

export default function Button(props: Props): JSX.Element {
  const { children, disabled, loading, variant = 'contained', ...restOfProps } = props

  return (
    <MuiButton disabled={disabled || loading} variant={variant} {...restOfProps}>
      {loading ? (
        <CircularProgress
          css={css`
            && {
              color: white;
            }
          `}
          size="1.6rem"
        />
      ) : (
        children
      )}
    </MuiButton>
  )
}
